if (!customElements.get('cart-add-toast')) {
  customElements.define(
    'cart-add-toast',
    class CartAddToast extends HTMLElement {
      constructor() {
        super();
        this.hideTimer = null;
        this.productTitle = this.querySelector('[data-toast-product-title]');
        this.message = this.querySelector('[data-toast-message]');
        this.imageWrapper = this.querySelector('[data-toast-image-wrapper]');
        this.image = this.querySelector('[data-toast-image]');
        this.closeButton = this.querySelector('[data-toast-close]');
        this.openCartButton = this.querySelector('[data-toast-open-cart]');

        this.closeButton?.addEventListener('click', () => this.hide());
        this.openCartButton?.addEventListener('click', () => this.openCart());
        this.addEventListener('mouseenter', () => this.pauseTimer());
        this.addEventListener('mouseleave', () => this.startTimer());
        this.addEventListener('focusin', () => this.pauseTimer());
        this.addEventListener('focusout', () => this.startTimer());

        document.addEventListener('cart:updated', async (event) => {
          await this.refreshCartSections();
          this.show(event.detail?.item);
        });
      }

      normalizeItems(cartData) {
        if (!cartData) return [];
        if (Array.isArray(cartData.items)) return cartData.items;
        if (cartData.id || cartData.key || cartData.product_title || cartData.title) return [cartData];
        return [];
      }

      getProductTitle(item) {
        if (!item) return '';
        return item.product_title || item.product?.title || item.title || '';
      }

      getImageUrl(item) {
        if (!item) return '';
        const featuredImage = item.featured_image;
        if (typeof featuredImage === 'string') return featuredImage;
        return featuredImage?.url || item.image || item.product?.featured_image || '';
      }

      show(cartData) {
        const items = this.normalizeItems(cartData);
        if (!items.length) return;

        const item = items[items.length - 1];
        const title = this.getProductTitle(item);
        const showImage = this.dataset.showImage === 'true';
        const imageUrl = showImage ? this.getImageUrl(item) : '';

        if (items.length > 1) {
          if (this.productTitle) this.productTitle.textContent = '';
          if (this.message) {
            const template = this.dataset.multipleMessage || '[count] productos se añadieron al carrito';
            this.message.textContent = template.replace('[count]', items.length);
          }
        } else {
          if (this.productTitle) this.productTitle.textContent = title;
          if (this.message) {
            const suffix = this.dataset.singleMessage || ' se añadió al carrito';
            this.message.textContent = title ? ` ${suffix.trim()}` : suffix.trim();
          }
        }

        if (this.imageWrapper && this.image) {
          if (imageUrl && items.length === 1) {
            this.image.src = imageUrl;
            this.image.alt = title;
            this.imageWrapper.hidden = false;
          } else {
            this.image.removeAttribute('src');
            this.image.alt = '';
            this.imageWrapper.hidden = true;
          }
        }

        this.hidden = false;
        requestAnimationFrame(() => this.classList.add('is-visible'));
        this.startTimer();
      }

      hide() {
        this.pauseTimer();
        this.classList.remove('is-visible');
        window.setTimeout(() => {
          if (!this.classList.contains('is-visible')) this.hidden = true;
        }, 250);
      }

      startTimer() {
        this.pauseTimer();
        const duration = Number(this.dataset.duration) || 4000;
        this.hideTimer = window.setTimeout(() => this.hide(), duration);
      }

      pauseTimer() {
        if (this.hideTimer) {
          window.clearTimeout(this.hideTimer);
          this.hideTimer = null;
        }
      }

      openCart() {
        this.hide();
        const drawer = document.querySelector('cart-drawer');
        const trigger = document.querySelector('#cart-icon-bubble');
        if (drawer?.open) drawer.open(trigger || this.openCartButton);
        else if (window.routes?.cart_url) window.location.href = window.routes.cart_url;
      }

      async refreshCartSections() {
        if (!window.routes?.cart_url) return;

        try {
          const separator = window.routes.cart_url.includes('?') ? '&' : '?';
          const response = await fetch(`${window.routes.cart_url}${separator}sections=cart-drawer,cart-icon-bubble`);
          if (!response.ok) return;
          const sections = await response.json();

          const drawer = document.querySelector('cart-drawer');
          const drawerHTML = sections['cart-drawer'];
          if (drawer && drawerHTML) {
            const parsed = new DOMParser().parseFromString(drawerHTML, 'text/html');
            const nextDrawer = parsed.querySelector('cart-drawer');
            if (nextDrawer) {
              drawer.innerHTML = nextDrawer.innerHTML;
              drawer.classList.toggle('is-empty', nextDrawer.classList.contains('is-empty'));
              drawer.bindOverlay?.();
            }
          }

          const cartIcon = document.getElementById('cart-icon-bubble');
          const iconHTML = sections['cart-icon-bubble'];
          if (cartIcon && iconHTML) {
            const parsed = new DOMParser().parseFromString(iconHTML, 'text/html');
            const nextIcon = parsed.querySelector('#cart-icon-bubble') || parsed.querySelector('.shopify-section');
            if (nextIcon) cartIcon.innerHTML = nextIcon.id === 'cart-icon-bubble' ? nextIcon.innerHTML : nextIcon.innerHTML;
          }
        } catch (error) {
          console.error('Unable to refresh cart after add:', error);
        }
      }
    }
  );
}
